import { Component, OnInit, OnDestroy } from '@angular/core';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import {
  FormModeEnum,
  ToolbarItem,
  TableActionParams,
  NotificationService,
  ModalService,
  BackendService,
  FieldStructure,
  TableSettings,
  CustomModalService,
  TableActionEnum,
  FilterSettings,
} from 'beyond-util';
import { EnumService } from '../../../services/enum.service';
import { Subscription } from 'rxjs/Subscription';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';

@Component({
  selector: 'app-tipovi-korekcija',
  templateUrl: './tipovi-korekcija.component.html',
})
export class TipoviKorekcijaComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _customModalService: CustomModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _enumService: EnumService
  ) {
    super(_backendService, _modalService, _notificationService);
  }
  private _subscriptions: Array<Subscription> = [];

  public showDetails: boolean;
  public _data: any;
  public _dataCount: any;

  ngOnInit() {
    super.ngOnInit();
    this._enumService.registerPrimenaKorekcije();
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  refreshTable() {
    this.setId(this._data);
    this.setRbr(this._data);
    this.orderListCount = this._dataCount;
    this.orderList = this._data;
  }

  alterSettings(settings) {
    settings.additable = false;
    settings.deletable = false;
    settings.editable = false;
    settings.inlineAdding = false;
    settings.inlineEditing = false;
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSCEN_KOR,
          FormName.PregledKorekcija,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          if (!this.settingsTable) {
            this.alterSettings(data['Settings']);
            this.setSettings(data['Settings']);
          }
          this._data = data['ServiceData']['Data'];
          this._dataCount = data['ServiceData']['DataSumCount'];
          this.setAllFields();
          this.refreshTable();
        })
    );
  }

  fetchSingleEntity() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSCEN_KOR,
          FormName.PregledSpotova,
          EndpointTypes.SingleEntity,
          '',
          this.order.Id ? this.order.Id : null
        )
        .subscribe(data => {
          this.fieldStructure = new FieldStructure(data.Settings, 'header');
          this.showDetails = true;
          this.order = this.order.Id ? data.ServiceData[0] : {};

          this.setInfobar(true, 'Milenković Marina', this.order.DatumIzmene);
        })
    );
  }

  onTableActionView() {
    this.fetchSingleEntity();
    this.changeMode(FormModeEnum.View);
  }

  getViewModeToolbarItems() {
    return [];
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/tipovi-korekcija/tipovi-korekcija.component.ts